import Service from "../Service";
import AccountService from "./AccountService";

const service = new Service();
const account = new AccountService();
export default class NoteService {
	constructor(clientId) {
		this.clientId = clientId;
	}

	static GetNotes(clientId) {
		return service.request('ClientNotes', {
			get: {
				clientId: clientId
			}
		});
	}

	static SaveNote(note) {
		console.log("SaveNote:", note)
		if (!(note.note || '').trim()) {
			return Promise.reject({error: 'Empty Note'});
		}
		if (!note.clientId) {
			return Promise.reject({error: 'Invalid ClientID'})
		}
		let req = (note.clientNoteId) ? 'ClientNotes/' + note.clientNoteId : 'ClientNotes';
		let options = {};
		let method = (note.clientNoteId) ? 'put' : 'post';

		if (!note.userId) {
			note.userId = account.userId;
		}

		options[method] = note;
		return service.request(req, options);
	}

	getNotes() {
		return NoteService.GetNotes(this.clientId);
	}

	addNote(note) {
		return NoteService.SaveNote({note: note, clientId: this.clientId});
	}
}



// WEBPACK FOOTER //
// ./src/api/services/NoteService.js